import { useEffect, useRef, useState } from "react";
import { WEBSITE_URL } from "../app/nav";
import { t } from "../lib/sprache";
import { aufWahlHoeren, einstellungenOeffnen, einstellungenOffen, ladeGoogleTag, leseWahl, seiteMitEinwilligung, waehle } from "../lib/einwilligung";

/**
 * Cookie-Banner auf Anmelden, Registrieren und Einrichtung (hängt in WebLayout und StartRahmen, zeigt sich nur dort), Vertrieb 27.10.2026: erscheint, solange
 * keine Wahl getroffen ist, oder nach „Cookie-Einstellungen“. „Ablehnen“ und „Akzeptieren“ sind gleich gestaltet, nichts
 * ist vorausgewählt. Mit Zustimmung lädt das Google-Tag (lib/einwilligung.ts). In Einbettungen der Website nie.
 */
export function CookieHinweis() {
  const [, neu] = useState(0);
  // Beim erneuten Öffnen bekommt das Banner selbst den Fokus, kein Knopf (sonst wirkt eine Wahl vorausgewählt)
  const banner = useRef<HTMLElement>(null);
  useEffect(() => aufWahlHoeren(() => neu((n) => n + 1)), []);
  useEffect(() => { if (typeof window !== "undefined" && seiteMitEinwilligung(window.location.pathname)) ladeGoogleTag(); }, []);
  const offen = einstellungenOffen();
  useEffect(() => { if (offen) banner.current?.focus(); }, [offen]);
  // Ohne Browser (Vorschau-Render der Tests) und in Einbettungen der Website nichts
  if (typeof document === "undefined" || !seiteMitEinwilligung(window.location.pathname) || new URLSearchParams(window.location.search).has("embed")) return null;
  if (leseWahl() && !offen) return null;
  return (
    <section ref={banner} tabIndex={-1} className="co-einwilligung" role="region" aria-labelledby="co-einwilligung-h">
      <p className="co-einwilligung-h" id="co-einwilligung-h">{t("Cookies für Werbung", "Cookies for advertising")}</p>
      <p>
        {t(
          "Mit deiner Zustimmung setzen Google Ireland Ltd. und Meta Platforms Ireland Ltd. Cookies, damit wir sehen, ob unsere Anzeigen bei Google, Instagram und Facebook zu neuen Testkonten, Abos oder Demo-Anfragen führen, und dir dort später wieder Anzeigen von CreatorOffice zeigen können. Google und Meta nutzen die Daten auch für eigene Zwecke, etwa zur Personalisierung von Werbung. Dabei können Daten in die USA übermittelt werden. Ohne Zustimmung wird nichts geladen. Deine Wahl kannst du jederzeit unter „Cookie-Einstellungen“ unten auf der Seite ändern.",
          "With your consent, Google Ireland Ltd. and Meta Platforms Ireland Ltd. set cookies so we can see whether our ads on Google, Instagram and Facebook lead to new trial accounts, subscriptions or demo requests and show you CreatorOffice ads there again later. Google and Meta also use the data for their own purposes, such as personalising ads. Data may be transferred to the USA. Without consent, nothing is loaded. You can change your choice at any time under “Cookie settings” at the bottom of the page.",
        )}{" "}
        <a href={`${WEBSITE_URL}/datenschutz.html#cookies`} target="_blank" rel="noreferrer">{t("Datenschutzerklärung", "Privacy policy (German)")}</a>
      </p>
      <div className="co-einwilligung-knoepfe">
        <button type="button" onClick={() => waehle("nein")}>{t("Ablehnen", "Decline")}</button>
        <button type="button" onClick={() => waehle("ja")}>{t("Akzeptieren", "Accept")}</button>
      </div>
    </section>
  );
}

/** „Cookie-Einstellungen“ in der Fußzeile: öffnet das Banner erneut */
export function CookieEinstellungenKnopf() {
  if (typeof window === "undefined" || !seiteMitEinwilligung(window.location.pathname)) return null;
  return <button type="button" onClick={einstellungenOeffnen}>{t("Cookie-Einstellungen", "Cookie settings")}</button>;
}
